import { ProfileExport } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { getSectors } from "../../../helpers/get_sectors";
import { CustomType, Position } from "../types";
import { Field } from "./field";

type SectorsProps = {
  translationKey: string;
  customTypes: CustomType[];
  profile: {
    id: number;
    enabled: boolean;
    email: string;
    name: string;
    jobTitle: string;
    companyName: string;
    summary: string;
    contactInformationItems: {
      type: string;
      text: string;
    }[];
    positions: { items: Position[] };
    customTypes: CustomType[];
    _originalData: ProfileExport;
  };
};

export const Sectors = ({ customTypes, profile, translationKey }: SectorsProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "export" });

  const sectorsType = customTypes.find(({ type }) => type.name === "sectors");

  if (!sectorsType) {
    return null;
  }

  const allSectors = getSectors(profile);
  return allSectors.length ? (
    <Field title={t(`${translationKey}.sectors` as unknown as TemplateStringsArray)}>
      <ul>
        {allSectors.map(({ id, value }) => (
          <li key={id}>
            <div>{value}</div>
          </li>
        ))}
      </ul>
    </Field>
  ) : null;
};
